var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfoConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F4F8FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 30,
    fill: "#E7F0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0003 21.6641C29.8753 21.6641 21.667 29.8724 21.667 39.9974C21.667 50.1224 29.8753 58.3307 40.0003 58.3307C50.1253 58.3307 58.3337 50.1224 58.3337 39.9974C58.3337 29.8724 50.1253 21.6641 40.0003 21.6641ZM38.1537 34.8891C38.537 34.1341 38.8203 33.7757 39.0553 33.5891C39.232 33.4491 39.472 33.3307 40.0003 33.3307C41.042 33.3307 41.667 34.1141 41.667 34.9607C41.667 35.4241 41.577 35.6541 41.3303 35.9474C40.9853 36.3574 40.347 36.8557 39.0837 37.6907L38.3337 38.1841V41.6641C38.3337 42.1061 38.5093 42.53 38.8218 42.8426C39.1344 43.1551 39.5583 43.3307 40.0003 43.3307C40.4424 43.3307 40.8663 43.1551 41.1788 42.8426C41.4914 42.53 41.667 42.1061 41.667 41.6641V39.9691C42.5703 39.3457 43.3287 38.7491 43.8787 38.0957C44.6737 37.1524 45.0003 36.1457 45.0003 34.9607C45.0003 32.5107 43.112 29.9974 40.0003 29.9974C38.8603 29.9974 37.852 30.2907 36.987 30.9757C36.1803 31.6141 35.6303 32.4924 35.1803 33.3841C35.0758 33.5798 35.0113 33.7945 34.9909 34.0155C34.9704 34.2366 34.9943 34.4594 35.0611 34.6711C35.1279 34.8827 35.2364 35.0789 35.38 35.2481C35.5237 35.4173 35.6997 35.5561 35.8978 35.6563C36.0958 35.7565 36.3118 35.8162 36.5333 35.8318C36.7547 35.8474 36.9769 35.8186 37.1871 35.7472C37.3972 35.6757 37.591 35.563 37.7569 35.4156C37.9229 35.2683 38.0578 35.0893 38.1537 34.8891ZM41.667 47.4974C41.667 47.0554 41.4914 46.6314 41.1788 46.3189C40.8663 46.0063 40.4424 45.8307 40.0003 45.8307C39.5583 45.8307 39.1344 46.0063 38.8218 46.3189C38.5093 46.6314 38.3337 47.0554 38.3337 47.4974V48.3307C38.3337 48.7728 38.5093 49.1967 38.8218 49.5092C39.1344 49.8218 39.5583 49.9974 40.0003 49.9974C40.4424 49.9974 40.8663 49.8218 41.1788 49.5092C41.4914 49.1967 41.667 48.7728 41.667 48.3307V47.4974Z",
    fill: "#2246DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoConfirm);
export default __webpack_public_path__ + "static/media/icon_info_confirm.8969f3e1686cbfda27c64ff882dff181.svg";
export { ForwardRef as ReactComponent };